<template>
  <div class="row" v-if="can_access('fdrate','view')">
    <div v-if="show">
      <FDRateForm :formReRender ="formReRender"/>
    </div>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import FDRateForm from '@/components/Accounts/FDRateForm';
import common from '@/assets/js/common.js';

export default {
  name: 'FDRate',
  components: { Widget, FDRateForm},
  mixins: [common],
  data() {
    return {
      row: {},
      show: true
    };
  },
  methods: {
    formReRender(response) {
      if(response.code==0){
        this.show = false;
        this.$nextTick(function(){
          this.show = true;
        });
      }
    },
  },
  created() {
    
  },
};
</script>